<template>
  <div class="gradient-color-picker">
    <div class="picker-container">
      <div class="color-inputs">
        <div class="color-item">
          <label>起始颜色</label>
          <el-color-picker
              v-model="startColor"
              show-alpha
              @change="updateGradient"
          ></el-color-picker>
          <el-input-number
              v-model="startPosition"
              :min="0"
              :max="100"
              :step="1"
              size="small"
              @change="updateGradient"
              style="width: 100px; margin-left: 10px;"
          ></el-input-number>
          <span style="margin-left: 5px;">%</span>
        </div>
        <div class="color-item">
          <label>结束颜色</label>
          <el-color-picker
              v-model="endColor"
              show-alpha
              @change="updateGradient"
          ></el-color-picker>
          <el-input-number
              v-model="endPosition"
              :min="0"
              :max="100"
              :step="1"
              size="small"
              @change="updateGradient"
              style="width: 100px; margin-left: 10px;"
          ></el-input-number>
          <span style="margin-left: 5px;">%</span>
        </div>
      </div>

      <div class="direction-select">
        <label>渐变方向</label>
        <el-select v-model="direction" @change="updateGradient" placeholder="选择方向">
          <el-option label="从上到下" value="to bottom"></el-option>
          <el-option label="从左到右" value="to right"></el-option>
          <el-option label="从左上到右下" value="to bottom right"></el-option>
          <el-option label="从右上到左下" value="to bottom left"></el-option>
        </el-select>
      </div>

      <div class="preview-container">
        <label>预览效果</label>
        <div class="preview" :style="{ background: gradientValue }"></div>
      </div>
<!--      <div class="gradient-value">-->
<!--        <label>CSS 值</label>-->
<!--        <el-input-->
<!--          v-model="gradientValue"-->
<!--          readonly-->
<!--          size="small"-->
<!--        ></el-input>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'GradientColorPicker',
  props: {
    value: {
      type: String,
      default: '#FFFFFF'
    }
  },
  data() {
    return {
      startColor: 'rgba(64, 158, 255, 1)',
      endColor: 'rgba(103, 194, 58, 1)',
      direction: 'to bottom',
      startPosition: 0,
      endPosition: 100
    }
  },
  computed: {
    gradientValue() {
      console.log('开始颜色' + this.startColor)
      console.log('结束颜色' + this.endColor)
      return `linear-gradient(${this.direction}, ${this.startColor} ${this.startPosition}%, ${this.endColor} ${this.endPosition}%)`
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        console.log("============触发解析")
        if (val && val.includes('linear-gradient')) {
          this.parseGradient(val)
        } else if (val) {
          // 如果是纯色，设置为起始和结束颜色相同
          this.startColor = val
          this.endColor = val
        }
      }
    }
  },
  methods: {
    updateGradient() {
      this.$emit('input', this.gradientValue)
      this.$emit('change', this.gradientValue)
    },
    parseGradient(gradient) {
      console.log("============解析渐变字符串：" + gradient)
      // 解析渐变字符串，支持 rgba() 格式和位置百分比
      // 匹配 linear-gradient(方向, 颜色1 位置1%, 颜色2 位置2%)
      const match = gradient.match(/linear-gradient\((.*)\)/)
      if (match) {
        const content = match[1]

        // 分离方向和颜色
        const parts = []
        let currentPart = ''
        let depth = 0

        for (let i = 0; i < content.length; i++) {
          const char = content[i]
          if (char === '(') {
            depth++
          } else if (char === ')') {
            depth--
          } else if (char === ',' && depth === 0) {
            parts.push(currentPart.trim())
            currentPart = ''
            continue
          }
          currentPart += char
        }
        if (currentPart) {
          parts.push(currentPart.trim())
        }

        if (parts.length >= 3) {
          this.direction = parts[0]

          // 解析起始颜色和位置
          const startMatch = parts[1].match(/^(.+?)\s+(\d+)%$/)
          if (startMatch) {
            this.startColor = startMatch[1].trim()
            this.startPosition = parseInt(startMatch[2])
          } else {
            this.startColor = parts[1]
            this.startPosition = 0
          }

          // 解析结束颜色和位置
          const endMatch = parts[2].match(/^(.+?)\s+(\d+)%$/)
          if (endMatch) {
            this.endColor = endMatch[1].trim()
            this.endPosition = parseInt(endMatch[2])
          } else {
            this.endColor = parts[2]
            this.endPosition = 100
          }

          console.log("开始颜色" + this.startColor + " 位置:" + this.startPosition + "%")
          console.log("结束颜色" + this.endColor + " 位置:" + this.endPosition + "%")
        }
      }
    }
  }
}
</script>

<style scoped>
.gradient-color-picker {
  width: 100%;
}

.picker-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.color-inputs {
  display: flex;
  gap: 20px;
}

.color-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.color-item label {
  font-size: 14px;
  color: #606266;
  min-width: 70px;
}

.direction-select {
  display: flex;
  align-items: center;
  gap: 10px;
}

.direction-select label {
  font-size: 14px;
  color: #606266;
  min-width: 70px;
}

.direction-select .el-select {
  flex: 1;
}

.preview-container {
  display: flex;
  gap: 8px;
}

.preview-container label {
  font-size: 14px;
  color: #606266;
}

.preview {
  flex: 1;
  height: 60px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

.gradient-value {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gradient-value label {
  font-size: 14px;
  color: #606266;
}
</style>
